const context = {
  setScreenReview: ({ state }, payload) => {
    state.context.screenReview = payload
  },
}

export { context }
